package io.horion.cv.models

enum class JobStatus {
    ACTIVE, EXPIRED, FILLED
}